import { TermsAcceptanceState, termsAcceptanceInitialState } from './State'

import {
  SET_TERMS_AND_CONDITIONS,
  SET_PRIVACY_POLICY,
  SET_IS_LOADING_DATA,
  RESET,
  TermsAcceptanceAction
} from './Actions'

function termsAcceptanceReducer(state: TermsAcceptanceState, action: TermsAcceptanceAction): TermsAcceptanceState {
  switch (action.type) {
    case SET_TERMS_AND_CONDITIONS:
      return Object.assign({}, state, { termsAndConditions: action.payload })
    case SET_PRIVACY_POLICY:
      return Object.assign({}, state, { privacyPolicy: action.payload })
    case SET_IS_LOADING_DATA:
      return Object.assign({}, state, { isLoadingData: action.payload })
    case RESET:
      return termsAcceptanceInitialState
    default:
      return state
  }
}

export default termsAcceptanceReducer
